
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_swvr5_66",
  "button": "awsui_button_vjswe_swvr5_70",
  "variant-normal": "awsui_variant-normal_vjswe_swvr5_132",
  "disabled": "awsui_disabled_vjswe_swvr5_150",
  "variant-primary": "awsui_variant-primary_vjswe_swvr5_157",
  "variant-link": "awsui_variant-link_vjswe_swvr5_182",
  "variant-icon": "awsui_variant-icon_vjswe_swvr5_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_swvr5_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_swvr5_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_swvr5_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_swvr5_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_swvr5_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_swvr5_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_swvr5_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_swvr5_418",
  "button-no-text": "awsui_button-no-text_vjswe_swvr5_537",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_swvr5_541",
  "full-width": "awsui_full-width_vjswe_swvr5_544",
  "button-compact": "awsui_button-compact_vjswe_swvr5_561",
  "icon-left": "awsui_icon-left_vjswe_swvr5_584",
  "icon-right": "awsui_icon-right_vjswe_swvr5_589",
  "icon": "awsui_icon_vjswe_swvr5_584",
  "link": "awsui_link_vjswe_swvr5_608",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_swvr5_608"
};
  